export default {
  red: '#F22525',
  blackGrey: '#373435',
  orange: '#F2AC20',
  green: '#43A047',
  grey: '#6D6D6D',
  orangeLight: '#F79A56',
  darkGrey: '#7A7A7A',
};
